'use client';

export { Text, Title } from 'rizzui';
